import { useCurrentUser } from "../../../hooks/useCurrentUser";
import React, { useState, useEffect } from "react";
import { Offcanvas, OffcanvasBody } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormControl, Menu, MenuItem, Button, Select,Modal, Tooltip, ListSubheader } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { DataGrid } from "@mui/x-data-grid";
import { CiExport, CiFilter, CiImport,CiViewList } from "react-icons/ci";
import { Box, Checkbox, IconButton, Typography, Avatar } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate, useParams } from "react-router-dom";
import { BsThreeDotsVertical } from "react-icons/bs";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import ReactQuill from "react-quill-new";
import { format, subDays } from "date-fns";
import Loader, { BtnLoader } from "../Loader";
import CommonDeleteDialog from "../CommonDelete";
import {setTimesheetProjectSpan, setTimesheetFromDate, setTimesheetToDate, setprojectName } from "../../../selectSlice";
import { CustomFooter, CustomNoRowsOverlay } from "../OverlayGrid";
import ImportTimesheet from "../TimesheetImport";
import { CustomCalendar } from "../TimesheetCalendar";
import { CommonExportComponent, CommonExportFormat } from "../CommonTimesheetExport";
import { CommonAddLogHours, CommonTimesheetFilter } from "../CommonAddLogHour";
import { MilestonLogsExportComponent } from "../../ProjectModule/milestones/MilestonLogsExport";
import { MilestoneLogsFilterComponent } from "../../ProjectModule/milestones/MilestoneLogsFilter";
import { postResource, postdatas } from "../../../apis/apiService";
import apiSlice, {
  useFetchTimeSheetLogDetailsQuery,
  useFetchTimesheetModuleQuery,
  useFetchTotalLogHoursInProjectTabQuery,
  useFetchTotalLogHoursQuery,
} from "../../../slice/logdetailSlice";
import { usePersistentFilter } from "../../../assets/hooks/usePersistentFilter";
import CommonImportProject from "../../../pages/projects/CommonImportProject";
import { extractTextFromHTML } from "../../../utils/textUtils";
import { MdContentCopy, MdHistory } from "react-icons/md";
import { RiFileEditLine } from "react-icons/ri";
import { useTheme } from "../../../ThemeContext";
import { openInNewTab } from "../../../utils/openInNewTab";
import { useTimeLogSaved } from "../../utilisation/TimeLogSavedProvider";


export const isQuillContentEmpty = (content) => {
  const stripped = content.replace(/<(.|\n)*?>/g, "").trim();
  return stripped.length === 0;
};

const CommonTimeSheetTable = ({
  showPath,
  updatePath,
  isModule,
  isProject,
  isTask,
  isIssue,
  overrideProjectId,       // pass project_id when used inside MilestoneDetail
  filterByMilestoneName,   // when set, auto-filter logs for this milestone
  filterByMilestoneId,     // when set, pass milestone_id to API for server-side filtering
}) => {
  const { isDarkMode } = useTheme();
  // const [expandedRows, setExpandedRows] = useState({});

  // Persist expanded/collapsed state of table rows in sessionStorage
  // so they remain open across re-renders, adding new logs, or navigating away and back.
  const [expandedRows, setExpandedRows] = useState(() => {
    const saved = sessionStorage.getItem("timesheetExpandedRows");
    return saved ? JSON.parse(saved) : {};
  });

  useEffect(() => {
    sessionStorage.setItem("timesheetExpandedRows", JSON.stringify(expandedRows));
  }, [expandedRows]);

  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [projects, setProjects] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showQuillPopup, setShowQuillPopup] = useState(false);
  const [quillContent, setQuillContent] = useState("");
  const [timelogFilter, setTimelogFilter] = useState([]);
  const [showExportPage, setShowExportPage] = useState(false);
  const dispatch = useDispatch();
  const { notifyTimeLogSaved } = useTimeLogSaved();
  const [selectedRowId, setSelectedRowId] = useState(null);
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  //console.log("login_user in pproject:", login_user);
  const { role: login_user_role } = login_user;
  const { id: login_user_id } = useCurrentUser();
  const [menuOpen, setMenuOpen] = useState(null);
  const open = Boolean(menuOpen);
  const [showImport, setShowImport] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [filter, setFilter] = usePersistentFilter( "timesheetModuleFilter", login_user_role === "CLIENT" || login_user_role === "ADMIN" ? 1 : 6 );
  const [ProjectFilter, setProjectFilter] = useState("user");
  const [milestoneFilter, setMilestoneFilter] = useState("all");
  const { id: routeId } = useParams();
  // Use overrideProjectId when provided (e.g. MilestoneDetail page)
  const id = overrideProjectId || routeId;

  // When inside Milestone Logs tab, force view_type=1 (All Timesheets)
  // so Manager/Employee can see ALL users' logs for that milestone, not just their own
  const effectiveViewType = filterByMilestoneName ? 1 : filter;
  const [totalHours, setTotalHours] = useState(null);
  const [paginationModel, setPaginationModal] = useState({ page: 0, pageSize: 25 });
  const [clearFilter, setClearFilter] = useState(false);
  const [milestoneFilterValues, setMilestoneFilterValues] = useState(null);
  //console.log("show log hours id", id);
  const [checkedRows, setCheckedRows] = useState({});
  const [multipleCloning, setMultipleCloning] = useState(false);
  const [singleCloningId, setSingleCloningId] = useState(null);

  const handleOpenMenu = (event) => {
    setMenuOpen(event.currentTarget);
  };

  // Handle menu close
  const handleCloseMenu = () => {
    setMenuOpen(null);
  };

  const [projectSpan, setProjectSpan] = useState(() => {
    return localStorage.getItem("timesheetProjectSpan") || "today";
  });

  const [selectionRange, setSelectionRange] = useState(() => {
    const saved = localStorage.getItem("timesheetDateRange");
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        ...parsed,
        startDate: new Date(parsed.startDate),
        endDate: new Date(parsed.endDate),
      };
    }
    return {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    };
  });

  useEffect(() => {
    if (projectSpan === "project_span") {
      const nullDateRange = {
        startDate: null,
        endDate: null,
        key: "selection",
      };
      localStorage.setItem("timesheetDateRange", JSON.stringify(nullDateRange));
    } 
    else {
      localStorage.setItem(
        "timesheetDateRange",
        JSON.stringify(selectionRange)
      );
    }

    localStorage.setItem("timesheetProjectSpan", projectSpan);
  }, [projectSpan, selectionRange]);

  const fromDate =
    projectSpan === "project_span"
      ? ""
      : selectionRange.startDate
        ? format(selectionRange.startDate, "yyyy-MM-dd")
        : "";

  const toDate =
    projectSpan === "project_span"
      ? ""
      : selectionRange.endDate
        ? format(selectionRange.endDate, "yyyy-MM-dd")
        : "";

  const [updatedSubtask, setUpdatedSubtask] = useState({
    // Set initial state values if required
    start_time: "",
    end_time: "",
    Date: null, // or other fields as needed
    logHourse: 0,
    dashBoard: "",
    // Add other fields if necessary
  });

  const ModuleTableQuery = useFetchTimesheetModuleQuery(
    {
      project_span: projectSpan,
      from_date: fromDate,
      to_date: toDate,
      view_type: filter,
      group_by: ProjectFilter,
    },
    { skip: !isModule } // Only fire for module-level timesheet view
  );

  const moduleTotalLogHours = useFetchTotalLogHoursQuery(
    {
      project_span: projectSpan,
      from_date: fromDate,
      to_date: toDate,
      view_type: filter,
      group_by: ProjectFilter,
    },
    { skip: !isModule } // Only fire for module-level timesheet view
  );

  const projectTableQuery = useFetchTimeSheetLogDetailsQuery(
    {
      id,
      project_span: projectSpan,
      from_date: fromDate,
      to_date: toDate,
      view_type: effectiveViewType,
      group_by: ProjectFilter,
      milestone_id: filterByMilestoneId || undefined,
    },
    {
      skip: !id,
      refetchOnMountOrArgChange: true,
    }
  );

  const ProjectTotalLogHours = useFetchTotalLogHoursInProjectTabQuery(
    {
      id,
      project_span: projectSpan,
      from_date: fromDate,
      to_date: toDate,
      view_type: effectiveViewType,
      group_by: ProjectFilter,
    },
    { skip: !id || !!filterByMilestoneId }
  );

  const data = isModule
    ? ModuleTableQuery.data
    : isProject
      ? projectTableQuery.data
      : null;
  // console.log("project_data :", data);

  const refetch = isModule
    ? ModuleTableQuery.refetch
    : isProject
      ? projectTableQuery.refetch
      : () => { };
  const total_log_hours = isModule
    ? moduleTotalLogHours.data
    : isProject
      ? ProjectTotalLogHours.data
      : null;

  const tableLoading = isModule ? ModuleTableQuery.isLoading : projectTableQuery.isLoading;
  const tableFetching = isModule ? ModuleTableQuery.isFetching : projectTableQuery.isFetching;
  const totalHoursLoading = isModule ? moduleTotalLogHours.isLoading : ProjectTotalLogHours.isLoading;
  const isGridLoading = tableLoading || tableFetching || totalHoursLoading;


  const total_log_hours_refetch = (arg) => {
    if (isModule) {
      moduleTotalLogHours.refetch?.(arg);
    } else if (isProject && !filterByMilestoneId) {
      ProjectTotalLogHours.refetch?.(arg);
    }
  };

  const handleDashboardSave = async () => {
    // Update the row data
    const updatedSubtask = data
      .find((project) =>
        project.subtasks.some((subtask) => subtask.id === selectedRowId)
      )
      .subtasks.find((subtask) => subtask.id === selectedRowId);

    const updatedRow = { ...updatedSubtask, dashBoard: quillContent };

    // Save to the database
    await handleSubtaskUpdate(updatedRow);

    // Update the local state
    const updatedProjects = data.map((project) => {
      // Create a deep copy of each project
      return {
        ...project,
        subtasks: project.subtasks.map((subtask) => {
          if (subtask.id === selectedRowId) {
            return { ...subtask, dashBoard: quillContent }; // Create a new subtask object
          }
          return subtask; // Return the original subtask
        }),
      };
    });
    setProjects(updatedProjects); // Update state with the new array
    // Close the popup
    setShowQuillPopup(false);
  };

  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":").map(Number);
    const period = hours >= 12 ? "PM" : "AM";
    const convertedHours = hours % 12 || 12; // Convert 0 or 12 to 12 for AM/PM format
    return `${convertedHours}:${minutes.toString().padStart(2, "0")} ${period}`;
  };
  useEffect(() => {
    total_log_hours_refetch?.();
  }, [data]);

  // Clear checked rows when date/filter ranges change or data updates (e.g. after a delete)
  useEffect(() => {
    setCheckedRows({});
  }, [projectSpan, fromDate, toDate, filter, ProjectFilter, data, timelogFilter]);

  //console.log("total_log_hourse :", data);

  const [showProject, setShowProject] = useState(false);
  const { reset } = useForm();

  const handleShowProject = () => {
    dispatch(setTimesheetProjectSpan(projectSpan)); // Example value
    dispatch(setTimesheetFromDate(fromDate));
    dispatch(setTimesheetToDate(toDate));
    // dispatch(setShowProjectPopup(true));
    setShowProject(true);
  };

  const navigate = useNavigate();
  const toggleExpandRow = (rowId) => {
    /*
    setExpandedRows((prevExpandedRows) => {
      // If the clicked row is already expanded, collapse it
      if (prevExpandedRows[rowId]) {
        return { ...prevExpandedRows, [rowId]: false };
      }
      // Otherwise, close all other rows and expand the clicked one
      return { [rowId]: true };
    });
    */

    // timesheet table la oru row click panna expand agum, and another row click pannalum expand la irukum previous row.
    // When a row in the timesheet table is clicked, it expands, and if another row is clicked, the previously expanded row still remains expanded.
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [rowId]: !prevExpandedRows[rowId],
    }));
  };

  const handleMenuOpen = (event, task) => {
    setMenuAnchorEl(event.currentTarget);
    // console.log("task_rowsss :", task);
    const taskName = task.user || task.other_log_entries || "Unknown Task";
    setSelectedTask({
      id: task.id,
      name: taskName,
      project_id: task.parentId,
      project_name: task.project_title,
      approval_status: task.approval_status,
    });
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleMenuAction = (action) => {
    //console.log(
    //   `timesheet_detail_response  viewTimesheet detail:${action} task: ${selectedTask}`
    // );
    // console.log("task_rowss :", selectedTask);

    dispatch(setprojectName(selectedTask.project_name));
    localStorage.setItem("project_id", selectedTask?.project_id);
    navigate(`/projects/projectDetail/${selectedTask?.project_id}/timesheet/TimeSheetDetail/${selectedTask?.id}`);
    handleMenuClose();
  };

  const handleViewDetailInNewTab = (action) => {
    //console.log(
    //   `timesheet_detail_response  viewTimesheet detail:${action} response: ${selectedTask}`
    // );
    localStorage.setItem("project_id", selectedTask?.project_id);
    const url = `/projects/projectDetail/${selectedTask?.project_id}/timesheet/TimeSheetDetail/${selectedTask?.id}`;
    openInNewTab(url); // Open in a new tab
    handleMenuClose();
  };

  const initialMilestoneLogs = React.useMemo(() => {
    if (!filterByMilestoneName || !Array.isArray(data)) return [];
    return data
      .map((row) => {
        const filteredSubtasks = (row.subtasks || []).filter(
          (sub) => {
            if (filterByMilestoneId && sub.milestone_id) {
              return String(sub.milestone_id) === String(filterByMilestoneId);
            }
            return sub.milestone &&
              sub.milestone.trim().toLowerCase() ===
                filterByMilestoneName.trim().toLowerCase();
          }
        );
        return {
          ...row,
          subtasks: filteredSubtasks,
        };
      })
      .filter((row) => row.subtasks.length > 0);
  }, [data, filterByMilestoneName, filterByMilestoneId]);

  // const flattenedRows = React.useMemo(() => {
  const filteredSourceData = React.useMemo(() => {
    // const rows = [];
    let sourceData = [];

    if (timelogFilter?.length > 0) {
      // timelogFilter.forEach((row) => {
      //   rows.push(row);
      //   if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
      //     row.subtasks.forEach((subtask) => {
      //       rows.push({ ...subtask });
      //     });
      //   }
      // });
      sourceData = timelogFilter;
    }
    // else if (!clearFilter && Array.isArray(data)) {
    else if (!clearFilter && Array.isArray(data)) {
      // data.forEach((row) => {
      sourceData = data;
    }

    // Apply milestone filter if active
    if (filterByMilestoneName) {
      // Specific milestone: filter subtasks where milestone === filterByMilestoneName or matches milestone_id
      sourceData = sourceData
        .map((row) => {
          let filteredSubtasks = (row.subtasks || []).filter(
            (sub) => {
              if (filterByMilestoneId && sub.milestone_id) {
                return String(sub.milestone_id) === String(filterByMilestoneId);
              }
              return sub.milestone &&
                sub.milestone.trim().toLowerCase() ===
                  filterByMilestoneName.trim().toLowerCase();
            }
          );

          if (milestoneFilterValues) {
            const { Users, Tasks, Issues, StartDate, EndDate, billingType, createdBy, timesheet_type } = milestoneFilterValues;

            filteredSubtasks = filteredSubtasks.filter((sub) => {
              if (Array.isArray(Users) && Users.length > 0 && !Users.includes(sub.owner_id)) {
                return false;
              }
              // if (Array.isArray(Tasks) && Tasks.length > 0) {
              //   const subTaskId = sub.task_id || sub.issue_id || sub.task_general_issue || sub.user;
              //   if (!Tasks.includes(subTaskId)) return false;
             const hasActiveTaskFilter = Array.isArray(Tasks) && Tasks.length > 0;
              const hasActiveIssueFilter = Array.isArray(Issues) && Issues.length > 0;
              if (hasActiveTaskFilter || hasActiveIssueFilter) {
                let match = false;
                if (hasActiveTaskFilter) {
                  const subTaskId = sub.task_id || ((sub.log_type === "TASK" || sub.logType === "TASK") && (sub.task_general_issue || sub.user));
                  if (subTaskId && Tasks.includes(subTaskId)) match = true;
                }
                if (hasActiveIssueFilter) {
                  const subIssueId = sub.issue_id || ((sub.log_type === "ISSUE" || sub.logType === "ISSUE") && (sub.task_general_issue || sub.user));
                  if (subIssueId && Issues.includes(subIssueId)) match = true;
                }
                if (!match) return false;
              }
              if (billingType && sub.billingType !== billingType) {
                return false;
              }
              if (createdBy && sub.owner_id !== createdBy) {
                return false;
              }
              if (timesheet_type && sub.timesheet_type !== timesheet_type) {
                return false;
              }
              if (StartDate && dayjs(sub.Date).isBefore(dayjs(StartDate).startOf('day'))) {
                return false;
              }
              if (EndDate && dayjs(sub.Date).isAfter(dayjs(EndDate).endOf('day'))) {
                return false;
              }
              return true;
            });
          }

          // Recalculate totals for filtered subtasks
          let totalMins = 0;
          let billableMins = 0;
          let nonBillableMins = 0;

          filteredSubtasks.forEach((sub) => {
            const parts = (sub.logHourse || "00:00").split(":");
            const h = parseInt(parts[0], 10) || 0;
            const m = parseInt(parts[1], 10) || 0;
            const mins = h * 60 + m;
            totalMins += mins;
            if (sub.billingType === "BILLABLE") {
              billableMins += mins;
            } else {
              nonBillableMins += mins;
            }
          });

          const formatLogHours = (mins) => {
            const h = Math.floor(mins / 60);
            const m = mins % 60;
            const decimal = (mins / 60).toFixed(2).replace(/\.00$/, "");
            return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")} (${decimal})`;
          };

          return {
            ...row,
            subtasks: filteredSubtasks,
            logHourse: [
              formatLogHours(totalMins),
              formatLogHours(billableMins),
              formatLogHours(nonBillableMins),
            ],
          };
        })
        .filter((row) => row.subtasks.length > 0);
    } 
    else if (milestoneFilter === "milestone") {
      sourceData = sourceData
        .map((row) => {
          const filteredSubtasks = (row.subtasks || []).filter(
            (sub) => sub.milestone && sub.milestone.toLowerCase() !== "none"
          );
          // return { ...row, subtasks: filteredSubtasks };

          // Recalculate totals for parent row based on filtered subtasks
          let totalMins = 0;
          let billableMins = 0;
          let nonBillableMins = 0;

          filteredSubtasks.forEach((sub) => {
            const parts = (sub.logHourse || "00:00").split(":");
            const h = parseInt(parts[0], 10) || 0;
            const m = parseInt(parts[1], 10) || 0;
            const mins = h * 60 + m;
            totalMins += mins;
            if (sub.billingType === "BILLABLE") {
              billableMins += mins;
            } else {
              nonBillableMins += mins;
            }
          });

          const formatLogHours = (mins) => {
            const h = Math.floor(mins / 60);
            const m = mins % 60;
            const decimal = (mins / 60).toFixed(2).replace(/\.00$/, "");
            return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")} (${decimal})`;
          };

          return {
            ...row,
            subtasks: filteredSubtasks,
            logHourse: [
              formatLogHours(totalMins),
              formatLogHours(billableMins),
              formatLogHours(nonBillableMins),
            ]
          };
        })
        .filter((row) => row.subtasks.length > 0);
    }

    return sourceData;
  }, [data, timelogFilter, clearFilter, milestoneFilter, filterByMilestoneName, milestoneFilterValues]);

  const flattenedRows = React.useMemo(() => {
    const rows = [];
    // sourceData.forEach((row) => {
    filteredSourceData.forEach((row) => {

      rows.push(row);
      if (expandedRows[row.id] && Array.isArray(row.subtasks)) {
        row.subtasks.forEach((subtask) => {
          rows.push({ ...subtask });
        });
      }
    });
    // }
    return rows;
    // }, [data, expandedRows, timelogFilter, clearFilter]);
    // }, [data, expandedRows, timelogFilter, clearFilter, milestoneFilter]);
  }, [filteredSourceData, expandedRows]);

  const filteredTotal = React.useMemo(() => {
    // Show total when specific milestone filter OR milestoneFilter dropdown is set
    if (milestoneFilter === "all" && !filterByMilestoneName) return null;
    let totalMinutes = 0;
    let count = 0;
    // flattenedRows.forEach((row) => {
    //   if (row.isSubtask && row.logHourse) {
    filteredSourceData.forEach((row) => {
      if (Array.isArray(row.subtasks)) {
        row.subtasks.forEach((sub) => {
          count++;
          // const parts = row.logHourse.split(":");
          const parts = (sub.logHourse || "00:00").split(":");
          const h = parseInt(parts[0], 10);
          const m = parseInt(parts[1], 10);
          if (!isNaN(h) && !isNaN(m)) {
            totalMinutes += h * 60 + m;
          }
        });
      }
    });
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")} (${count})`;
    // }, [flattenedRows, milestoneFilter]);
  }, [filteredSourceData, milestoneFilter, filterByMilestoneName]);

  const handleRowEdit = (newRow) => {
    if (!newRow.isSubtask) {
      toast.error("Only subtasks can be edited.");
      return;
    }

    //console.log("Edited Subtask:", newRow.timePeriod);

    // Trigger API update
    handleSubtaskUpdate(newRow);

    // Update the state with the new data
    const updatedProjects = [...projects];
    const parentIndex = updatedProjects.findIndex(
      (project) => project.id === newRow.parentId
    );

    if (parentIndex !== -1) {
      const subtaskIndex = updatedProjects[parentIndex].subtasks.findIndex(
        (subtask) => subtask.id === newRow.id
      );

      if (subtaskIndex !== -1) {
        const updatedSubtask = {
          ...updatedProjects[parentIndex].subtasks[subtaskIndex],
          ...newRow,
          timePeriod:
            newRow.start_time && newRow.end_time
              ? `${convertTo12HourFormat(
                newRow.start_time
              )} - ${convertTo12HourFormat(newRow.end_time)}`
              : "",
        };

        updatedProjects[parentIndex].subtasks[subtaskIndex] = updatedSubtask;
        setProjects(updatedProjects); // Update the local state
      }
    }
  };
  const handleClearFilter = () => {
    reset();
    handleClear();
  };

  const handleApplyMilestoneFilter = (filterValues) => {
    setMilestoneFilterValues(filterValues);
    setShowFilter(false);
    toast.success("Filter applied successfully!");
  };

  const handleClearMilestoneFilter = () => {
    setMilestoneFilterValues(null);
    setShowFilter(false);
  };



  const handleClear = () => {
    sessionStorage.removeItem("timesheet_filter");
    refetch();
    total_log_hours_refetch();
    setClearFilter(false);
    setTimelogFilter([]);
    setTotalHours(null);
    setMilestoneFilter("all");
    setMilestoneFilterValues(null);
  };

  const handleCalendarFilter = (filteredData) => {
    if (!filteredData || !filteredData.time_logs?.length) {
      setTimelogFilter([]);
      setTotalHours(null);
      return; // Γ¢ö Don't refetch if there's no data
    }

    const transformedRows = transformFilteredData(filteredData);
    setTimelogFilter(transformedRows);
    setTotalHours(filteredData.total_time_logs_hours);
    total_log_hours_refetch();
  };

  const handleApplyFilter = (filteredData = null) => {
    if (!filteredData) {
      const storedData = sessionStorage.getItem("timesheet_filter");
      filteredData = storedData ? JSON.parse(storedData) : null;
    }

    const isResponse = filteredData && filteredData.hasOwnProperty('time_logs');

    if (!filteredData || !filteredData.time_logs?.length) {
      setTimelogFilter([]);
      setTotalHours(null);
      if (isResponse) {
        setShowFilter(false);
        setClearFilter(true);
        toast.error("No filtered data found");
      }
      return; // Γ¢ö No need to apply filter or refetch
    }

    const transformedRows = transformFilteredData(filteredData);
    setTimelogFilter(transformedRows);
    setShowFilter(false);
    setClearFilter(true);
    setTotalHours(filteredData.total_time_logs_hours);
    total_log_hours_refetch(filteredData);
  };

  useEffect(() => {
    const storedFilter = sessionStorage.getItem("timesheet_filter");
    if (storedFilter) {
      const parsedFilter = JSON.parse(storedFilter);
      handleApplyFilter(parsedFilter); // Γ£à Now correctly works
    }
  }, []);

  const transformFilteredData = (filteredData) => {
    return filteredData?.time_logs?.map((log, index) => {
      const subtasks = Array.isArray(log.time_logs)
        ? log.time_logs.map((timeLog) => ({
          id: timeLog.time_logs_id,
          timeLogId: timeLog.time_logs_id,
          user: timeLog.log_title,
          ownerName: timeLog.owner_name || timeLog.group_by,
          owner_id: timeLog.user_id || timeLog.owner_id,
          task_general_issue: timeLog.task_general_issue,
          logHourse: timeLog.hours_in_text,
          Date: timeLog.log_date,
          other_log_entries: timeLog.other_log_entries,
          timePeriod:
            timeLog.start_time && timeLog.end_time
              ? `${convertTo12HourFormat(
                timeLog.start_time
              )} - ${convertTo12HourFormat(timeLog.end_time)}`
              : "",
          dashBoard: (() => {
            const div = document.createElement("div");
            div.innerHTML = timeLog.notes;
            return div.innerText.trim();
          })(),
          project_title: timeLog.project_title,
          approval_status: timeLog.approval_status,
          start_time: timeLog.start_time,
          end_time: timeLog.end_time,
          billingType: timeLog.billing_type,
          task_id: timeLog.task_id,
          issue_id: timeLog.issue_id,
          timesheet_type: timeLog.timesheet_type,
          reported_manager_id: timeLog.reported_manager_id,
          reported_manager_name: timeLog.reported_manager_name,
          added_name: timeLog.added_name,
          milestone: timeLog.milestone,
          isSubtask: true,
          parentId: timeLog.project_id,
        }))
        : [];

      return {
        id: index,
        Date: log.log_date,
        userName: log.group_by,
        logHourse: [
          `${log.total_hours}`,
          `${log.billable_hours}`,
          `${log.non_billable_hours}`,
        ],
        timePeriod: "",
        dashBoard: "",
        isTask: true,
        subtasks,
      };
    });
  };

  const hadleExport = (exportData) => {
    setShowExportPage(false);
  };
  useEffect(() => { }, [timelogFilter]);
  const handleTimeChange = (field, value) => {
    setUpdatedSubtask({
      ...updatedSubtask,
      [field]: value,
    });
  };
  const formatTimeTo24Hour = (time) => {
    const isPM = time.toUpperCase().includes("PM");
    const isAM = time.toUpperCase().includes("AM");

    const [hours, minutes] = time
      .replace(/AM|PM/i, "") // Remove AM/PM
      .trim()
      .split(":")
      .map(Number);

    if (isNaN(hours) || isNaN(minutes)) {
      throw new Error(`Invalid time value: ${time}`);
    }

    let formattedHours = hours;
    if (isPM && hours !== 12) {
      formattedHours += 12; // Convert PM to 24-hour format
    } else if (isAM && hours === 12) {
      formattedHours = 0; // Convert 12 AM to 0 (midnight)
    }

    return `${formattedHours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const handleSubtaskUpdate = async (updatedSubtask) => {
    console.log("subtask_update_data :", updatedSubtask);

    let startTime = null;
    let endTime = null;
    const isValidDate = (date) =>
      /^\d{4}-\d{2}-\d{2}$/.test(date) && !isNaN(new Date(date).getTime());

    const isValidTimeFormat = (time) =>
      time === "24:00" || /^([01]\d|2[0-3]):([0-5]\d)$/.test(time);
    const timeToMinutes = (time) => {
      const [hours, minutes] = time.split(":").map(Number);
      return hours * 60 + minutes;
    };
    if (!updatedSubtask.logHourse) {
      toast.error("Time is required.");
      return;
    }
    // Validation
    if (updatedSubtask.logHourse) {
      const time = updatedSubtask.logHourse;

      // Check if it's parsable (roughly valid time-like format)
      if (!/^(\d{1,2}):([0-5]\d)$/.test(time)) {
        toast.error("Invalid time format. Use HH:MM ");
        return;
      }

      // Check if it's over 24:00
      if (timeToMinutes(time) > 1440) {
        toast.error("Log hours cannot exceed 24:00.");
        return;
      }

      // Now check actual allowed format (with 24:00 exception)
      if (!isValidTimeFormat(time)) {
        toast.error("Invalid time format. Use HH:mm .");
        return;
      }
    }
    if (!updatedSubtask.Date) {
      toast.error("Date is required.");
      return;
    }

    // Date validation
    if (updatedSubtask.Date && !isValidDate(updatedSubtask.Date)) {
      toast.error("Invalid date. Use YYYY-MM-DD.");
      return;
    }

    // Extract and convert start/end time if available
    if (updatedSubtask.timePeriod) {
      const [startTimeRaw, endTimeRaw] = updatedSubtask.timePeriod
        .split("-")
        .map((time) => time.trim());

      try {
        startTime = startTimeRaw ? formatTimeTo24Hour(startTimeRaw) : null;
        endTime = endTimeRaw ? formatTimeTo24Hour(endTimeRaw) : null;

        if (startTime === endTime) {
          toast.error("Start time and end time cannot be the same.");
          return;
        }
      } catch (err) {
        toast.error(err.message || "Invalid time format in timePeriod.");
        return;
      }
    }

    // Construct payload
    const postData = {
      log_date: updatedSubtask.Date,
      notes: updatedSubtask.dashBoard || "",
    };

    if (startTime && endTime) {
      postData.start_time = startTime;
      postData.end_time = endTime;
    } 
    else if (
      updatedSubtask.logHourse !== undefined &&
      updatedSubtask.logHourse !== null
    ) {
      postData.hours_in_text = updatedSubtask.logHourse;
    }

    try {
      const response = await postResource(
        updatePath,
        "update",
        updatedSubtask.timeLogId,
        postData
      );

      toast.success(response.message);
      dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      refetch();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleCheckboxChange = (rowId) => {
    setCheckedRows((prev) => ({
      ...prev,
      [rowId]: !prev[rowId], // Toggle checkbox state
    }));
  };
  const handleDashboardClick = (row) => {
    setSelectedRowId(row.id);
    setQuillContent(row.dashBoard || ""); // Load existing notes or empty
    setShowQuillPopup(true);
  };
  useEffect(() => {
    // showAllTimeLogEntities();
  }, []);

  // Duplicate log
  const [duplicateAnchorEl, setDuplicateAnchorEl] = useState(null);
  const [duplicateRow, setDuplicateRow] = useState(null);
  const [copyEditRow, setCopyEditRow] = useState(null);

  const handleDuplicateClick = (event, row) => {
    setDuplicateAnchorEl(event.currentTarget);
    setDuplicateRow(row);
  };

  const handleDuplicateClose = () => {
    setDuplicateAnchorEl(null);
    setDuplicateRow(null);
  };

  // Strip seconds from stored times like "09:30:00" ΓåÆ "09:30" (server expects H:i format)
  const toHHMM = (time) => {
    if (!time) return null;
    const parts = time.split(":");
    return `${parts[0]}:${parts[1]}`; // keep only HH:MM
  };

  // Build a clone payload from a subtask row
  // Preserves: same task name (other_log_entries), same time period (start/end time or hours)
  const buildClonePayload = (row, overrideDate) => {
    const payload = {
      log_date: overrideDate,
      billing_type: row.billingType || "BILLABLE",
      notes: row.dashBoard || "",
      owner_id: login_user_id,
      project_id: row.parentId,
      timesheet_type: row.timesheet_type || "REGULAR",
      reported_manager_id: row.reported_manager_id,
    };

    // Carry the same log title: prefer other_log_entries (general log), else use task title
    //   other_log_entries: row.other_log_entries || row.user || "",
    // };


    // Added logs cloned for timesheet module, project/timesheet tab and task log hours
    if (row.task_id) {
      payload.task_id = row.task_id;
    }
    else if (row.issue_id) {
      payload.issue_id = row.issue_id;
    }
    else {
      payload.other_log_entries = row.other_log_entries || row.user || "";
    }

    // Time period: strip seconds ("09:30:00" ΓåÆ "09:30") before sending
    if (row.start_time && row.end_time) {
      payload.start_time = toHHMM(row.start_time);
      payload.end_time = toHHMM(row.end_time);
    } 
    else if (row.logHourse) {
      payload.hours_in_text = row.logHourse;
    } 
    else {
      payload.hours_in_text = "01:00";
    }
    return payload;
  };

  // 1-click: Clone to today
  // Opens an empty Add Time Log form.
  const openAddLogForm = () => {
    setCopyEditRow(null);
    setShowProject(true);
  };

  const handleCloneToCurrentDate = async (row) => {

    setSingleCloningId(`${row.id}_current`);
    const today = format(new Date(), "yyyy-MM-dd");
    const payload = buildClonePayload(row, today);

    try {
      await postdatas("timesheet", "add", payload);
      toast.success("Time log successfully cloned to current date");
      dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      refetch();
      total_log_hours_refetch();
      notifyTimeLogSaved(payload, { onAddAnother: openAddLogForm });
    }
    catch (err) {
      toast.error(err?.message || "Failed to clone log.");
    }
    finally {
      setSingleCloningId(null);
      handleDuplicateClose();
    }
  };

  // 1-click: Clone to previous day
  const handleCloneToPreviousDay = async (row) => {
    setSingleCloningId(`${row.id}_previous`);
    // Clone to the day before the existing log's date (clone to previuous date)
    const targetDate = format(subDays(new Date(row.Date), 1), "yyyy-MM-dd");
    const payload = buildClonePayload(row, targetDate);

    try {
      await postdatas("timesheet", "add", payload);
      toast.success("Time log successfully cloned to previous date");
      dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      refetch();
      total_log_hours_refetch();
      notifyTimeLogSaved(payload, { onAddAnother: openAddLogForm });
    } 
    catch (err) {
      toast.error(err?.message || "Failed to clone log.");
    } 
    finally {
      setSingleCloningId(null);
      handleDuplicateClose();
    }
  };

  // Bulk Clone to today
  const handleMultipleCloneToCurrentDate = async () => {
    const today = format(new Date(), "yyyy-MM-dd");
    const selectedIds = Object.keys(checkedRows).filter((key) => checkedRows[key]);

    if (!selectedIds.length) return;

    setMultipleCloning(true);
    let sourceData = timelogFilter?.length > 0 ? timelogFilter : (!clearFilter ? data : []);
    let rowsToClone = [];

    if (sourceData) {
      sourceData.forEach(row => {
        if (Array.isArray(row.subtasks)) {
          row.subtasks.forEach(sub => {
            if (selectedIds.includes(sub.id?.toString()) || selectedIds.includes(sub.id)) {
              rowsToClone.push(sub);
            }
          })
        }
      });
    }

    if (!rowsToClone.length) {
      toast.error("No valid subtasks found to clone.");
      setMultipleCloning(false);
      return;
    }

    try {
      const payloads = rowsToClone.map((row) => buildClonePayload(row, today));
      await Promise.all(payloads.map((payload) => postdatas("timesheet", "add", payload)));
      toast.success("Cloned selected logs to today successfully!");
      dispatch(apiSlice.util.invalidateTags(["Timesheet"]));
      setCheckedRows({});
      refetch();
      total_log_hours_refetch();
      notifyTimeLogSaved(payloads, { onAddAnother: openAddLogForm });
    } 
    catch (err) {
      // toast.error("Failed to clone some logs.");
      toast.error("You can't add time log more than 24 hrs per day");
    } 
    finally {
      setMultipleCloning(false);
    }
  };

  // 2-click: Open offcanvas pre-filled for Copy & Edit
  const handleCopyAndEdit = (row) => {
    handleDuplicateClose();
    setCopyEditRow(row);
    setShowProject(true);
  };

  // Navigate to detail for View Entry History
  const handleViewEntryHistory = (row) => {
    handleDuplicateClose();
    if (!row) return;
    localStorage.setItem("project_id", row.parentId);
    dispatch(setprojectName(row.project_title));
    navigate(`/projects/projectDetail/${row.parentId}/timesheet/TimeSheetDetail/${row.timeLogId || row.id}`);
  };


  const columns = [
    {
      field: "actions",
      headerName: "Action",
      width: 120,
      renderCell: (params) => {
        if (!params.row) return null;
        return (
          <Box display="flex" alignItems="center" gap={1}>
            {params.row.isTask && (
              <IconButton onClick={() => toggleExpandRow(params.row.id)}>
                {expandedRows[params.row.id] ? (
                  <ExpandLessIcon />
                ) : (
                  <ExpandMoreIcon />
                )}
              </IconButton>
            )}
            {params.row.isSubtask && (
              <Checkbox
                checked={!!checkedRows[params.row.id]} // Ensure boolean value
                onChange={() => handleCheckboxChange(params.row.id)}
              />
            )}
            {params.row.isSubtask && (
              <IconButton
                onClick={(event) => handleMenuOpen(event, params.row)}
                // disabled={params.row.isSubtask && !checkedRows[params.row.id]} // Disable if checkbox is unchecked
                disabled={!checkedRows[params.row.id]} // Disable if checkbox is unchecked
              >
                <MoreVertIcon sx={{ color: "gray" }} />
              </IconButton>
            )}
          </Box>
        );
      },
    },

    {
      field: "duplicate",
      headerName: "Duplicate",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
              }}
            >
              <Tooltip title="Duplicate Log">
                <IconButton
                  size="small"
                  onClick={(e) => handleDuplicateClick(e, params.row)}
                  sx={{
                    color: "rgba(18, 183, 159, 1)",
                    borderRadius: "50%",
                    padding: "8px",
                    transition: "all 0.2s ease",
                    backgroundColor: "transparent",
                    "&:hover": {
                      backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                    },
                  }}
                >
                  <MdContentCopy size={17} />
                </IconButton>
              </Tooltip>
            </Box>
          );
        }
        return null;
      },
    },

    {
      field: "user",
      headerName: "Task",
      width: 240,
      editable: false,
      renderCell: (params) => {
        if (params.row.isTask) {
          // Display log_date for task rows
          return (
            <Box
              display="flex"
              sx={{ cursor: "default" }}
              alignItems="center"
              gap={1}
            >
              <span style={{ fontWeight: "bold" }}>
                {login_user_role === "EMPLOYEE"
                  ? params.row.userName
                  : params.row.userName
                    ? params.row.userName
                    : params.row.other_log_entries}
              </span>
            </Box>
          );
        } else if (params.row.isSubtask) {
          const displayText =
            params.row.user ||
            params.row.group_by ||
            params.row.other_log_entries ||
            "ΓÇö";
          const initials = displayText
            .split(" ")
            .map((word) => word[0])
            .join("")
            .slice(0, 2)
            .toUpperCase();
          const handleClick = () => {
            navigate(
              `/projects/projectDetail/${params.row.parentId}/timesheet/TimeSheetDetail/${params.row.id}`
            );
            localStorage.setItem("project_id", params.row.parentId);
            dispatch(setprojectName(params.row.project_title));
          };
          return (
            <Box
              display="flex"
              onClick={handleClick}
              // sx={{cursor:"pointer"}}
              alignItems="center"
              gap={1}
            >
              <Avatar
                sx={{
                  bgcolor: "#1976d2",
                  width: 24,
                  height: 24,
                  fontSize: "0.75rem",
                }}
              >
                {initials}
              </Avatar>
              <span>{displayText}</span>
            </Box>
          );
        }
      },
    },

    {
      field: "project_title",
      headerName: "Project Name",
      width: 200,
    },

    {
      field: "logHourse",
      headerName: "Daily Log Hours",
      width: 200,
      editable: (params) => {
        console.log("Editable check:", {
          role: login_user_role,
          isSubtask: params.row.isSubtask,
          start: params.row.start_time,
          end: params.row.end_time,
          result:
            login_user_role !== "CLIENT" &&
            params.row.isSubtask &&
            (!params.row.start_time || !params.row.end_time),
        });

        return (
          login_user_role !== "CLIENT" &&
          params.row.isSubtask &&
          (!params.row.start_time || !params.row.end_time)
        );
      },
      // <- correct check
      align: "start",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <span>{params.value}</span>
            </Box>
          );
        }
        const logHours = Array.isArray(params.value)
          ? params.value
          : [params.value];
        const getColor = (index) => {
          if (params.row.isSubtask) return "black";
          return index === 0 ? "#00BF00" : index === 1 ? "#34C1FD" : "#FF955A";
        };
        return (
          <Box sx={{ display: "flex", gap: "8px" }}>
            {logHours.map((hour, index) => (
              <Box
                key={index}
                sx={{ color: getColor(index), fontWeight: "bold" }}
              >
                <Tooltip
                  title={
                    index === 0
                      ? "Total Hours"
                      : index === 1
                        ? "Billable Hours"
                        : "Non-Billable Hours"
                  }
                >
                  {hour}
                </Tooltip>
              </Box>
            ))}
          </Box>
        );
      },
    },

    {
      field: "ownerName",
      headerName: "User",
      width: 150,
      editable: false,
      align: "left",
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },

    {
      field: "Date",
      headerName: "Date",
      width: 150,
      // editable: (params) => params.row.isSubtask,
      editable: login_user_role === "CLIENT" ? false : true,
      align: "left",
      renderCell: (params) => {
        //console.log("params_value_task  date value:", params.row);
        if (params.row.isSubtask) {
          return (
            <Box>
              {/* edit data */}
              {/* <CustomCalendar /> */}
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },

    {
      field: "timePeriod",
      headerName: "Time Period",
      width: 180,
      align: "left",
      editable: true,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <span>{params.value}</span>
            </Box>
          );
        }
        return null;
      },
    },

    {
      field: "dashBoard",
      headerName: "Notes",
      width: 150,
      align: "left",
      // editable: (params) => params.row.isSubtask,
      editable: login_user_role === "CLIENT" ? false : true,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          const value = extractTextFromHTML(params.value);
          return (
            <div
              // className="d-flex align-items-center h-100 justify-content-center w-100"
              onClick={() => handleDashboardClick(params.row)} // Entire cell clickable
            >
              <Tooltip title={value}>
                {value.length > 12
                  ? value.substring(0, 12) + "..."
                  : value || "Edit Notes"}
              </Tooltip>
            </div>
          );
        }
        return null; // Return null for non-subtasks
      },
    },

    {
      field: "milestone",
      headerName: "Milestone Name",
      width: 160,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          const val = params.value;
          // Show empty cell if null or "None"
          if (!val || val.toLowerCase?.() === "none") return "";
          return (
            <Tooltip title={val}>
              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", display: "block", maxWidth: 140 }}>
                {val}
              </span>
            </Tooltip>
          );
        }
        return null;
      },
    },

    {
      field: "billingType",
      headerName: "Status",
      align: "left",
      width: 100,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          return (
            <Box>
              <Typography
                sx={{
                  color: params.value === "BILLABLE" ? "#34C1FD" : "#FF955A",
                  mt: 2,
                }}
              >
                {params.value}
              </Typography>
            </Box>
          );
        }
        return null; // Return null for non-subtasks
      },
    },

    {
      field: "timesheet_type",
      headerName: "Type",
      width: 100,
      editable: false,
      // renderCell: (params) => {
    },

    {
      field: "added_name",
      headerName: "Added By",
      width: 200,
      editable: false,
      // renderCell: (params) => {
    },

    {
      field: "reported_manager_name",
      headerName: "Report To",
      width: 200,
      editable: false,
      renderCell: (params) => {
        if (params.row.isSubtask) {
          const value = params.value;
          if (!value || value.toLowerCase?.() === "none") {
            return "------------";
          }
          return value;
        }
        return null;
      },
    },

    {
      field: "approval_status",
      headerName: "OT Status ",
      width: 200,
      editable: false,
    },
  ];

  const filterOptions = {
    predefined: [
      { label: "All Timesheets", value: 1 },
      { label: "All Pending", value: 2 },
      { label: "All Approved", value: 3 },
      { label: "All Billable", value: 4 },
      { label: "All Non-Billable", value: 5 },
    ],

    myViews: [
      { label: "My Timesheets", value: 6 },
      { label: "My Pending", value: 7 },
      { label: "My Approved", value: 8 },
      { label: "My Billable", value: 9 },
      { label: "My Non-Billable", value: 10 },
    ],
  };
  const ProjectFilterOptions = [
    { label: "Group By User", value: "user" },
    { label: "Group By Project", value: "project" },
  ];

  const handleFilterChange = (event) => {
    const value = event.target.value;
    //console.log("scope_filter_value", value);

    setFilter(value);
  };
  const handleProjectFilterChange = (event) => {
    const value = event.target.value;
    //console.log("scope_filter_value", value);

    setProjectFilter(value);
  };
  const handleCloseProject = () => {
    setShowProject(false);
  };

  const handleExportPage = () => {
    setShowExportPage(true);
    handleCloseMenu();
  };
  const showImportPopup = () => {
    setShowImport(true);
    handleCloseMenu();
  };

  const showExportPopup = () => {
    setShowExport(true);
    handleCloseMenu();
  };

  const handleShowFilter = () => {
    setShowFilter(true);
  };

  const handleImport = () => {
    refetch();
  };

  return (
    <>
      <Offcanvas
        show={showProject}
        placement="end"
        style={{ width: window.innerWidth > 768 ? "50%" : "85%" }}
        onHide={() => { setShowProject(false); setCopyEditRow(null); }}
      >
        <Offcanvas.Body className="p-0">
          <CommonAddLogHours
            // onApply={() => { handleCloseProject(); setCopyEditRow(null); }}
            // This code for only after filter record and add loghours without referceing data show            
            onApply={() => {
              handleCloseProject();
              setCopyEditRow(null);
              if (clearFilter) {
                handleClear();
              }
            }}
            onClear={() => reset()}
            onCancel={() => { handleCloseProject(); setCopyEditRow(null); }}
            span={projectSpan}
            fromDate={fromDate}
            toDate={toDate}
            refetchList={refetch}
            isModule={isModule}
            prefillData={copyEditRow}
            updatePath={updatePath}
            hideGeneralLog={!!filterByMilestoneName}
            onAddAnother={openAddLogForm}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showFilter}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {showFilter && (
          <Offcanvas.Body className="p-0">
            {filterByMilestoneName ? (
              <MilestoneLogsFilterComponent
                onApply={handleApplyMilestoneFilter}
                onClear={handleClearMilestoneFilter}
                onCancel={() => setShowFilter(false)}
                sourceData={initialMilestoneLogs}
                milestoneName={filterByMilestoneName}
                projectId={id}
                fromDate={fromDate}
                toDate={toDate}
                prefillData={milestoneFilterValues}
              />
            ) : (
              <CommonTimesheetFilter
                onApply={handleApplyFilter}
                onClear={handleClearFilter}
                refetchList={total_log_hours_refetch}
                onCancel={() => setShowFilter(false)}
                view_type={filter}
                project_span={projectSpan}
                from_date={fromDate}
                to_date={toDate}
                filterPath="timesheet/filter"
                ismodule={isModule}
                groupBy={ProjectFilter}
              />
            )}
          </Offcanvas.Body>
        )}

      </Offcanvas>
      <Offcanvas show={showExportPage} placement="end" style={{ width: "50%" }}>
        <OffcanvasBody>
          {filterByMilestoneName ? (
            <MilestonLogsExportComponent
              milestoneName={filterByMilestoneName}
              projectId={id}
              sourceData={initialMilestoneLogs}
              viewType={effectiveViewType}
              projectSpan={projectSpan}
              fromDate={fromDate}
              toDate={toDate}
              onCancel={() => setShowExportPage(false)}
              milestoneId={filterByMilestoneId}
            />
          ) : (
            <CommonExportComponent
              onApply={hadleExport}
              view_type={filter}
              // view_type={filter}
              project_span={projectSpan}
              from_date={fromDate}
              to_date={toDate}
              onCancel={() => setShowExportPage(false)}
              isModule={isModule}
              isTask={false}
            />
          )}
        </OffcanvasBody>
      </Offcanvas>

      {/* CommonExportFormat */}
      <Offcanvas show={showExport} placement="end" style={{ width: "50%" }}>
        <OffcanvasBody>
          <CommonExportFormat
            onApply={() => setShowExport(false)}
            onCancel={() => setShowExport(false)}
            refetchList={refetch}
            isModule={isModule}
          // onDocumentAdded={handleImport}
          // importPath="importTimesheet"
          />
        </OffcanvasBody>
      </Offcanvas>

      <Offcanvas show={showImport} placement="end" style={{ width: "50%" }}>
        <OffcanvasBody>
          <ImportTimesheet
            // onApply={hadleExport}
            onCancel={() => setShowImport(false)}
            refetchList={refetch}
            isModule={isModule}
            onDocumentAdded={handleImport}
            importPath="importTimesheet"
            project_id={id}
          />
        </OffcanvasBody>
      </Offcanvas>

      {isGridLoading ? (
        <Loader />
      ) : (
        <div style={{ padding: "9px 16px" }} className=" bg-white">
          <Box style={{ width: "100%", backgroundColor: "transparent" }}>
            {/* <div className="d-flex align-items-center justify-content-between"> */}
            <Box
              className="d-flex align-items-center justify-content-between"
              sx={{
                border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                borderRadius: "6px",
                padding: "12px 16px",
                marginBottom: "12px",
                backgroundColor: isDarkMode ? "transparent" : "#fff",
                gap: "10px",
                flexWrap: "nowrap",
                overflow: "hidden"
              }}
            >
              <div className="d-flex gap-2 align-items-center flex-shrink-0">
                <div>
                  {!(
                    login_user_role === "ADMIN" ||
                    login_user_role === "MANAGER" ||
                    login_user_role === "CLIENT"
                  ) && (
                      <FormControl>
                        <Select
                          value={filter}
                          onChange={handleFilterChange}
                          displayEmpty
                        >
                          <ListSubheader className="text-rgba-gray ps-3">
                            My Timesheets
                          </ListSubheader>
                          {filterOptions.myViews.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  {(login_user_role === "ADMIN" ||
                    login_user_role === "MANAGER" ||
                    login_user_role === "CLIENT") && (
                      <FormControl className="">
                        <Select
                          value={filter}
                          onChange={handleFilterChange}
                          displayEmpty
                        >
                          <ListSubheader className="text-rgba-gray ps-3">
                            All Timesheets
                          </ListSubheader>
                          {filterOptions.predefined.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}

                          <ListSubheader className="text-rgba-gray ps-3">
                            My Timesheets
                          </ListSubheader>
                          {filterOptions.myViews.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                </div>

                {/* Hide "Group By User" dropdown inside Milestone Logs tab */}
                {!filterByMilestoneName && (
                  <div>
                    <FormControl>
                      <Select
                        value={ProjectFilter}
                        onChange={handleProjectFilterChange}
                        displayEmpty
                        defaultValue={1}
                      >
                        {/* <ListSubheader className="text-rgba-gray ps-3">
                            My Timesheets
                          </ListSubheader> */}
                        {ProjectFilterOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                )}
                {/* Hide "All Logs" dropdown inside Milestone Logs tab - filter is auto-applied */}
                {!filterByMilestoneName && (
                  <div>
                    <FormControl>
                      <Select
                        value={milestoneFilter}
                        onChange={(e) => setMilestoneFilter(e.target.value)}
                        displayEmpty
                      >
                        <MenuItem value="all">All Logs</MenuItem>
                        <MenuItem value="milestone">Milestone Logs</MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                )}
              </div>

              <div className="flex-grow-1 d-flex justify-content-center">
                <CustomCalendar
                  selectionRange={selectionRange}
                  setSelectionRange={setSelectionRange}
                  projectSpan={projectSpan}
                  setProjectSpan={setProjectSpan}
                  clearFilter={clearFilter}
                  handleClear={handleClear}
                  setClearFilter={setClearFilter}
                  onApplyTransformedData={handleCalendarFilter}
                  refetch={refetch}
                  total_log_hours_refetch={total_log_hours_refetch}
                />
              </div>

              {/* <div className="text-end d-flex align-items-center gap-2"> */}
              <div className="d-flex flex-nowrap justify-content-end align-items-center flex-shrink-0" style={{ gap: "8px" }}>
                {login_user_role !== "CLIENT" &&
                  Object.values(checkedRows).filter(Boolean).length >= 2 && (

                    <Tooltip title="Selected records clone to current date">
                      <button
                        className="border-btn addmore_btn"
                        style={{ padding: "6px 16px", borderRadius: "5px", fontSize: "13px", whiteSpace: "nowrap" }}
                        onClick={handleMultipleCloneToCurrentDate}
                        disabled={multipleCloning}
                      >
                        {multipleCloning ? (
                          <BtnLoader />
                        ) : (
                          <>
                            <MdContentCopy className="me-2" />
                            Clone
                          </>
                        )}
                      </button>
                    </Tooltip>

                  )}
                {login_user_role !== "CLIENT" && (
                  <Button
                    className="rounded AddButton me-2"
                    sx={{ fontSize: "12px", padding: "5px 12px", whiteSpace: "nowrap", minWidth: "max-content" }}
                    onClick={handleShowProject}
                  >
                    Add Log Hours
                  </Button>
                )}

                {(clearFilter || milestoneFilterValues) && (
                  <button
                    className="addmore_btn"
                    onClick={handleClear}
                    style={{ padding: "6px 16px", fontSize: "13px", whiteSpace: "nowrap" }}
                  >
                    Clear filter
                  </button>
                )}
                <Tooltip title="Filter">
                  <IconButton
                    onClick={handleShowFilter}
                    sx={{
                      // color: "rgba(18, 183, 159., 1)",
                      backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                      borderRadius: "50%",
                      width: "39px",
                      height: "39px",
                      color: "rgba(18, 183, 159, 1)",
                      "&:hover": {
                        backgroundColor: "var(--icon-hover-bg)",
                      },
                      // mr: 2,
                    }}
                  >
                    <CiFilter className="pro-icon-s" />
                  </IconButton>
                </Tooltip>

                <Tooltip title="More Options">
                  <IconButton
                    onClick={handleOpenMenu}
                    sx={{
                      backgroundColor: isDarkMode
                        ? "rgba(67, 105, 255, 0.08)"
                        : "#F1F5FF",
                      borderRadius: "50%",
                      width: "39px",
                      height: "39px",
                      color: "rgba(18, 183, 159, 1)",
                      "&:hover": {
                        backgroundColor: "var(--icon-hover-bg)",
                      },
                    }}
                  >
                    <BsThreeDotsVertical className="pro-icon-s" />
                  </IconButton>
                </Tooltip>

                <Menu
                  anchorEl={menuOpen}
                  open={open}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    sx: {
                      backgroundColor: isDarkMode ? "#1e1e1e" : "#fff",
                      color: isDarkMode ? "#fff" : "inherit",
                      borderRadius: "8px",
                      boxShadow: isDarkMode ? "0px 5px 15px rgba(0,0,0,0.5)" : "0px 5px 15px rgba(0,0,0,0.1)",
                    }
                  }}
                >
                  {!filterByMilestoneName &&
                    (login_user_role === "ADMIN" ||
                      login_user_role === "MANAGER") && (
                      // <Tooltip title="Import">
                      <MenuItem>
                        <button
                          onClick={showImportPopup}
                          // className="border-0 bg-transparent text-decoration-none me-3 p-2"
                          className="border-0 bg-transparent text-decoration-none me-3 p-2 d-flex align-items-center"
                        >
                          <CiImport className="text-rgbr-blue pro-icon-s" />{" "}
                          <span className={isDarkMode ? "text-white mx-2 mt-2" : "text-dark mx-2 mt-2"}>Import</span>
                        </button>
                      </MenuItem>
                      // </Tooltip>macah
                    )}

                  {!filterByMilestoneName &&
                    (login_user_role === "ADMIN" ||
                      login_user_role === "MANAGER") && (
                      // <Tooltip title="Import">
                      <MenuItem>
                        <button
                          onClick={showExportPopup}
                          className="border-0 bg-transparent text-decoration-none me-3 p-2 d-flex align-items-center"
                        >
                          <CiExport className="text-rgbr-blue pro-icon-s" />
                          <span className={isDarkMode ? "text-white mx-2 mt-2" : "text-dark mx-2 mt-2"}>Export All</span>
                        </button>
                      </MenuItem>
                      // </Tooltip>
                    )}

                  {!filterByMilestoneName &&
                    (login_user_role === "ADMIN" ||
                      login_user_role === "MANAGER") && (
                      <MenuItem>
                        <CommonImportProject
                          // isProjectModule={false}
                          project_id={id}
                          isProjectModule={isModule ? true : false}
                          haveText={true}
                        />
                      </MenuItem>
                    )}

                  <MenuItem>
                    <button
                      className="border-0 bg-transparent text-decoration-none me-3 p-2 d-flex align-items-center"
                      onClick={handleExportPage}
                    >
                      <CiExport className="text-rgbr-blue pro-icon-s" />
                      <span className={isDarkMode ? "text-white mx-2 mt-2" : "text-dark mt-2 mx-2"}>Export</span>
                    </button>
                  </MenuItem>
                </Menu>
              </div>
              {/* </div> */}
            </Box>

            <DataGrid
              rows={flattenedRows}
              // columns={columns}
              // Hiden this duplicate column for only client login
              columns={columns.filter((col) => login_user_role === "CLIENT" ? col.field !== "duplicate" : true)}
              editMode="cell"
              isCellEditable={(params) => {
                const { field, row } = params;
                if (!row) return false;

                const hasStart = !!row.start_time;
                const hasEnd = !!row.end_time;

                if (!row.isSubtask) return false;

                // Γ£à Allow editing logHourse only if start or end time is missing
                if (field === "logHourse") {
                  return login_user_role !== "CLIENT" && (!hasStart || !hasEnd);
                }

                // Γ£à Allow editing timePeriod always (this represents start/end time entry)
                if (field === "timePeriod") {
                  return true;
                }
                if (field === "Date") return login_user_role !== "CLIENT";

                // Γ£à Allow dashBoard (notes) field editable for non-clients
                if (field === "dashBoard") return login_user_role !== "CLIENT";

                return false;
              }}
              getRowId={(row) => row.id}
              pagination
              paginationModel={paginationModel}
              onPaginationModelChange={setPaginationModal}
              pageSizeOptions={[25, 50, 75, 100]}
              disableSelectionOnClick
              disableColumnMenu
              disableColumnSorting
              disableColumnFilter
              disableColumnSelector
              loading={isGridLoading}
              autoHeight
              slots={{
                noRowsOverlay: CustomNoRowsOverlay,
                footer: () => (
                  <CustomFooter
                    totalLogHours={
                      flattenedRows.length === 0
                        ? "00:00 (0)"
                        : (milestoneFilter !== "all" || filterByMilestoneName)
                          ? filteredTotal
                          : totalHours ?? total_log_hours ?? "00:00"
                    }
                  />
                ),
              }}
              processRowUpdate={(updatedRow, originalRow) => {
                if (!originalRow.isSubtask) {
                  console.warn("Row_editing_blocked.");
                  toast.error("Only subtasks can be edited.");
                  return originalRow; // Prevent update
                }
                handleRowEdit(updatedRow);
                return updatedRow;
              }}
            />

            <Modal
              open={showQuillPopup}
              onClose={() => setShowQuillPopup(false)}
            >
              <Box
                className="bg-white"
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 600,
                  maxWidth: 500,
                  height: 300,
                  // bgcolor: "background.paper",
                  boxShadow: 10,
                  p: 2,
                }}
              >

                <ReactQuill
                  theme="snow"
                  value={quillContent}
                  onChange={(content) => setQuillContent(content)} // Update state
                  style={{ height: "150px", marginBottom: "20px" }}
                />

                {login_user_role !== "CLIENT" && (
                  <Box
                    display="flex"
                    marginTop={10}
                    justifyContent="flex-end"
                    gap={2}
                  >
                    <button
                      className="cancel_btn"
                      onClick={() => setShowQuillPopup(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="add_btn"
                      disabled={isQuillContentEmpty(quillContent)}
                      onClick={handleDashboardSave}
                    >
                      Save
                    </button>
                  </Box>
                )}
              </Box>
            </Modal>

            <Menu
              anchorEl={menuAnchorEl}
              open={Boolean(menuAnchorEl)}
              onClose={handleMenuClose}
            >
              <MenuItem onClick={() => handleMenuAction("View")}>
                <CiViewList className="me-2" color="blue" />
                View Details
              </MenuItem>
              <MenuItem
                onClick={() => handleViewDetailInNewTab("View in New Tab")}
              >
                <CiViewList className="me-2" color="blue" />
                View Details in New Tab
              </MenuItem>

              {/* <MenuItem onClick={() => handleDelete("Delete")}>Delete</MenuItem> */}
              {selectedTask && selectedTask.approval_status !== "APPROVED" && (
                <CommonDeleteDialog
                  name="Timelog"
                  id={selectedTask?.id}
                  statusName={selectedTask?.name}
                  url={"timesheet/delete"}
                  refetchList={refetch}
                  handleListClose={handleMenuClose}
                // secondRefetchList={}
                />
              )}
            </Menu>
          </Box>
        </div>
      )}

      {/* Duplicate Dropdown Menu */}
      <Menu
        anchorEl={duplicateAnchorEl}
        open={Boolean(duplicateAnchorEl)}
        onClose={handleDuplicateClose}
      >
        <MenuItem
          onClick={() => handleCloneToCurrentDate(duplicateRow)}
          disabled={singleCloningId === `${duplicateRow?.id}_current`}
        >
          {singleCloningId === `${duplicateRow?.id}_current` ? (
            <div className="d-flex align-items-center">
              <BtnLoader /> <span className="ms-2">Cloning...</span>
            </div>
          ) : (
            <>
              <MdContentCopy className="me-2 text-success" /> Clone to current date
            </>
          )}
        </MenuItem>

        <MenuItem
          onClick={() => handleCloneToPreviousDay(duplicateRow)}
          disabled={singleCloningId === `${duplicateRow?.id}_previous`}
        >
          {singleCloningId === `${duplicateRow?.id}_previous` ? (
            <div className="d-flex align-items-center">
              <BtnLoader /> <span className="ms-2">Cloning...</span>
            </div>
          ) : (
            <>
              <MdContentCopy className="me-2 text-info"/> Clone to previous day
            </>
          )}
        </MenuItem>

        <MenuItem onClick={() => handleCopyAndEdit(duplicateRow)}>
          <RiFileEditLine className="me-2 text-primary" /> Copy &amp; Edit Log
        </MenuItem>

        <MenuItem onClick={() => handleViewEntryHistory(duplicateRow)}>
          <MdHistory className="me-2 text-danger" /> View Entry History
        </MenuItem>
      </Menu>

    </>
  );
};
export default CommonTimeSheetTable;


